import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'

import { Box } from '@mui/system'
import { useState } from 'react'

import useStyles from './useStyles'
import StepperSeeMoreSuborganization from '../RightModals/StepperSeeMoreSuborganization'
import { NavLink } from 'react-router-dom'

export default function ModalMenuItemSuborganization ({
  item,
  setLoading,
  types
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const [stateSeeMore, setstateSeeMore] = useState(false)
  const classes = useStyles()

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listSeeMoreOrganization = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <StepperSeeMoreSuborganization
        setstateSeeMore={setstateSeeMore}
        item={item}
        types={types}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreOrganization('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({ item, onClose, setstateSeeMore }) {
  const classes = useStyles()

  return (
    <Box className={classes.boxStyle}>
      <Box className={classes.boxNav}>
        <IconButton
          onClick={() => {
            setstateSeeMore(true)
            onClose()
          }}
          className={classes.boxButton}
        >
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </IconButton>
      </Box>

      <NavLink
        to={`/storage/recycle/${item.suborganizationId}`}
        className={classes.boxNav}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
          className={classes.boxButton}
        >
          <Inventory2OutlinedIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver papelera interna
          </Typography>
        </IconButton>
      </NavLink>
      <NavLink
        to={`/suborganizations/${item.suborganizationId}/users`}
        className={classes.boxNav}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
          className={classes.boxButton}
        >
          <PersonOutlineIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver usuarios asociados
          </Typography>
        </IconButton>
      </NavLink>
      <NavLink
        to={`/ME/declarations/${item.suborganizationId}/declarations`}
        className={classes.boxNav}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
          className={classes.boxButton}
        >
          <ReceiptLongIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver declaraciones
          </Typography>
        </IconButton>
      </NavLink>
    </Box>
  )
}
